import Vue from 'vue'
import Router from 'vue-router'
import LandingView from '@/components/LandingView'
import AboutView from '@/components/pages/AboutView'
import KeyArticlesView from '@/components/pages/KeyArticlesView'
import InitiatorsView from '@/components/pages/InitiatorsView'
import ManagementView from '@/components/pages/ManagementView'
import AboutAuthorsView from '@/components/pages/AboutAuthorsView'
import AuthorsView from '@/components/pages/AuthorsView'
import BlogView from '@/components/pages/BlogView'
import ContactView from '@/components/pages/ContactView'
import InfographicsView from '@/components/pages/InfographicsView'
import VideoView from '@/components/pages/VideoView'
import ArticleView from '@/components/pages/ArticleView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: LandingView },

    // Articles
    { path: '/:slug', name: 'article', props: true, component: ArticleView },
    {
      path: '/articles/:id',
      name: 'articleById',
      props: { id: true, fromId: true },
      component: ArticleView
    },

    // Authors
    { path: '/authors', name: 'authors', component: AuthorsView },

    // Key Articles
    { path: '/key-articles', name: 'key_articles', component: KeyArticlesView },

    // Blog
    { path: '/blog', name: 'blog', component: BlogView },

    // Video
    { path: '/video', name: 'video', component: VideoView },

    // Infographics
    { path: '/infographics', name: 'infographics', component: InfographicsView },

    // Static
    { path: '/about', name: 'about', component: AboutView },
    { path: '/about/initiators', name: 'initiators', component: InitiatorsView },
    { path: '/about/management', name: 'management', component: ManagementView },
    { path: '/about/authors', name: 'aboutAuthors', component: AboutAuthorsView },
    { path: '/contact', name: 'contact', component: ContactView }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js